import { ChainType } from '@lifi/types';
export function isSolana(provider) {
    return provider.type === ChainType.SVM;
}
export const TokenProgramAddress = 'TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA';
//# sourceMappingURL=types.js.map